module.exports = __webpack_public_path__ + "images/gradients/gradient-earth.ace86a88c8caec7dc3a2.svg";